import { toInlineClasses } from "../../Utils";
import { actions } from "../../store/Store";
import { WidgetMention,New_WidgetMention } from '../../Templates'

let WidgetMentionTpl = actions.mergeTemplates(WidgetMention, 'WidgetMention');
let NewWidgetMentionTpl = actions.mergeTemplates(New_WidgetMention, 'WidgetMention');

class Mention extends AbstractMention {
	constructor(MentionID, data, options) {
		super(MentionID, data, options);
  if (options.widgetOptions.newDesign || (options.widgetOptions.newDesign2)) {
		this.Template = NewWidgetMentionTpl;
  }
  else {
	  this.Template = WidgetMentionTpl;
  }
	}

	AfterContentCreated(elm) {
		if (!elm) return;
		if (!this.contentObj.Elm) this.contentObj.Elm = elm;
		this.DetermineContentHeight(elm);
		if (elm.nextElementSibling) {
			let translateBtn = elm.closest('.mention').querySelector('.translate');
			if (translateBtn) {
				elm.closest('.body').insertBefore(translateBtn, elm.nextElementSibling);
			}
		}
	}

	render() {
		let Tpl = this.Template.str;

		let data = {
			mentionID: this.MentionID,
			sourceID: this.Data.SourceID,
			classes: toInlineClasses({
				animate: this.Options.animateMention.length > 0,
				animateVisible: this.MentionViewed
			}),
			hasLikes: this.Options.likes.show ? 'hasLikes' : '',
			components: {
				loader: this.Loader.render(),
				header: this.RenderMentionHeader(),
				body: this.RenderMentionBody(),
				translateBtn: this.RenderTranslateBtn(),
				moderation: this.Options.moderate ? this.RenderModerate() : '',
				likes: this.RenderMentionLikes()
			}
		};

		return doT.template(Tpl)(data);
	}
}

export default Mention


// WEBPACK FOOTER //
// ./src/app/components/widget/Mention.js